import { Injectable, OnInit } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from './../providers/authentication.service';
import { UserProfileModel } from './../models/userprofile/user-profile.model';
import { UtilityService } from './../providers/utility.service';
import { CMS_PERM } from './../config';


@Injectable()
export class UserProfileGuard implements CanActivate {
  loginSwitch: boolean = false;
  cmsUser: boolean = false;
  upgradeUser: boolean = false;
  noPermission: boolean = false;

  permission: any;

  id: any;
  rkey='';
  constructor(private router: Router, private authenticationService: AuthenticationService,
    private service: UtilityService) {
    this.loginSwitch = JSON.parse(sessionStorage.getItem('loginDropdownPopupSwitch'));
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this.rkey = route.paramMap.get('rkey');
    
    let userProfile: UserProfileModel;
    let permissionJson: any;
    this.authenticationService.setLoginSuccessUrl(state.url);
    if (this.isEscapePermission(state.url)) {
      return true;
    } else {
      let splitedUrlArray = state.url.split('/');
      if (this.authenticationService.checkIfAuthNeeded()) {
        if (sessionStorage.getItem('permissions') != null) {
          permissionJson = JSON.parse(sessionStorage.getItem('permissions'));
         

          for (let i = splitedUrlArray.length - 1; i > 0; i--) {
            let isInstanceExist = this.service.checkInstance(splitedUrlArray[i], permissionJson.perm);
            if (isInstanceExist === !null) {
              let returnedValue = this.service.checkPagePermission(splitedUrlArray[i], permissionJson.perm);
              if (returnedValue) {
                return true;
              } 
              console.log('user-profile.guard: 47');
              return this.handleUnAuthenticatedRequest(state.url);
            }
          }
              console.log('user-profile.guard: 51');
          return this.handleUnAuthenticatedRequest(state.url); 
        }
      } else {
        if (splitedUrlArray[1] === 'edit') {
          window.location.href = '/businessconsole/care?client=admin';
        }
        else if (this.loginSwitch) {
          if(state.url == "/support" || state.url == "/faq" || state.url == "/manageInventory" || state.url == "/productselection"){
            this.setCookies(state.url);
          }
          if (location.href.indexOf('selectstubid') == -1) {
            this.authenticationService.setLoginModalStatus(true);
          } else {
            alert('Please select a StubID to proceed.');
          }
        }
        else {
          if(state.url == "/support" || state.url == "/faq" || state.url == "/manageInventory" || state.url == "/productselection"){
            if (location.href.indexOf('selectstubid') == -1) {
              this.setCookies(state.url);
              let urls = state.url;
              let rKey_ = urls != '' && state.url.split("/")[1];
              window.location.href = `/businessconsole/login?rkey=${rKey_}`;
            } else {
              alert('Please select a StubID to proceed.');
            }
            
          }else{
            window.location.href = `/businessconsole/login?rkey=${this.rkey}`;
          }
          
        }
        return false;
      }
    }

  }
  handleError = (error) => { // Arrow function is necessary as the context should be Parent class
    return error;
  }

  isEscapePermission(url) {
    // Method to bypass permission based on business rules
    if (url && url.indexOf('cart') > 0) {
      const cartItem = sessionStorage.getItem('cart');
      if (!(cartItem !== null && JSON.parse(cartItem).lineItems !== null && JSON.parse(cartItem).lineItems.length > 0)) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  setCookies(url){
    let d = new Date();
    d.setTime(d.getTime() + (90*1000));
    let expires = "expires="+ d.toUTCString();
    let urlData = url != "" && url.split("/")[1];
    document.cookie= urlData+"=true; expires="+expires+"; domain=.att.com; path=/";
  }

  handleUnAuthenticatedRequest(stateurl) {
    this.router.navigate(['errorPage', 403]);
    return false;
  }
}
